/* import __COLOCATED_TEMPLATE__ from './brand-card.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import type { Brand } from 'embercom/components/new-settings/workspace/brands/types/brand';
import type { HelpCenter } from 'embercom/components/new-settings/workspace/brands/types/help-center';

interface Args {
  isInteractive: boolean;
  brand: Brand | undefined;
  helpCenters?: HelpCenter[];
  senderEmail?: string;
  aiAgentIdentity?: string | undefined;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

const BrandCard = templateOnlyComponent<Signature>();
export default BrandCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::BrandsNew::BrandCard': typeof BrandCard;
  }
}
